<div class="o-grid">
	<div class="o-grid__cell o-grid__cell--center-v u-no-p" *ngIf="!vm.reserveBookingMode">
		<div *ngIf="vm.chat.editingMessage" class="editing-banner">
			<i class="o-icon o-icon--edit u-no-mr" aria-hidden="true"></i> {{ vm.chat.editingMessage.content }}
			<button id="cancelEditButton" style="padding: 0; font-size: 0.6em;" type="button" class="c-button c-button--tp u-no-pv" (click)="vm.cancelEdit()">
				<i class="o-icon o-icon--cancel c-text c-text--main c-text--lg u-no-mr" aria-hidden="true" title="{{ 'Common.Cancel' | translate }}"></i>
				<span class="u-sr-only">{{ 'Common.Cancel' | translate }}</span>
			</button>
		</div>
		<form class="c-form">
			<div class="c-form__group u-no-m">
				<textarea id="chatTextInput" name="chatTextInput" class="c-form__input c-form__input--no-border c-form__input--sm" placeholder="{{ 'Call.Content.Type_Message' | translate}}" rows="1" [(ngModel)]="vm.chat.message" (keyup)="vm.handleKeyup($event)" (keypress)="vm.handleKeypress($event)" [readonly]="vm.loading"></textarea>
			</div>
		</form>
	</div>
	<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--center-v u-no-p" *ngIf="!vm.reserveBookingMode && vm.chat.message?.length && !vm.chat.editingMessage">
		<button id="sendTextMessageButton" type="button" class="c-button c-button--tp c-button--icon u-no-pv u-no-p@up-to-md" (click)="vm.sendTextMessage()" [disabled]="vm.loading">
			<i class="o-icon o-icon--send c-text c-text--main c-text--lg u-no-mr" aria-hidden="true" title="{{ 'Common.Send' | translate }}"></i>
			<span class="u-sr-only">{{ 'Common.Send' | translate }}</span>
		</button>
	</div>
	<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--center-v u-no-p" *ngIf="!vm.reserveBookingMode && vm.chat.message?.length && vm.chat.editingMessage">
		<button id="updateTextMessageButton" type="button" class="c-button c-button--tp c-button--icon u-no-pv u-no-p@up-to-md" (click)="vm.updateTextMessage()" [disabled]="vm.loading">
			<i class="o-icon o-icon--send c-text c-text--main c-text--lg u-no-mr" aria-hidden="true" title="{{ 'Common.Send' | translate }}"></i>
			<span class="u-sr-only">{{ 'Common.Send' | translate }}</span>
		</button>
	</div>
	<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--center-v u-no-p" *ngIf="!vm.reserveBookingMode && !vm.aiChatActive && vm.canAccessMentalHealthQuestionnaire && !vm.chat.message?.length">
        <button id="questionnaireSearchButton" type="button" class="c-button c-button--tp c-button--icon u-no-pv u-no-p@up-to-md" (click)="vm.openQuestionnaireSearch()" [disabled]="vm.processing">
            <i class="o-icon o-icon--doc c-text c-text--main c-text--lg u-no-mr" aria-hidden="true"></i>
            <span class="u-sr-only">{{ 'Services.Other.Search' | translate }}</span>
        </button>
    </div>
	<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--center-v u-no-p" *ngIf="!vm.reserveBookingMode && !vm.aiChatActive && vm.isMentalHealthServiceProvider && !vm.chat.message?.length">
		<button id="serviceProviderSearchButton" type="button" class="c-button c-button--tp c-button--icon u-no-pv u-no-p@up-to-md" (click)="vm.openServiceProviderSearch()" [disabled]="vm.processing">
			<i class="o-icon o-icon--user c-text c-text--main c-text--lg u-no-mr" aria-hidden="true" title="{{ 'Services.Other.Search' | translate }}"></i>
			<span class="u-sr-only">{{ 'Services.Other.Search' | translate }}</span>
		</button>
	</div>
	<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--center-v u-no-p" *ngIf="!vm.reserveBookingMode && !vm.aiChatActive && vm.canRecommendMedications && !vm.chat.message?.length">
		<button id="medicationSearchButton" type="button" class="c-button c-button--tp c-button--icon u-no-pv u-no-p@up-to-md" (click)="vm.openMedicationSearch()" [disabled]="vm.processing">
			<i class="o-icon o-icon--pills c-text c-text--main c-text--lg u-no-mr" aria-hidden="true" title="{{ 'Drug_Search.Open' | translate }}"></i>
			<span class="u-sr-only">{{ 'Drug_Search.Open' | translate }}</span>
		</button>
	</div>
	<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--center-v u-no-p" *ngIf="!vm.reserveBookingMode && !vm.aiChatActive && !vm.isPopup && !vm.chat.message?.length">
        <button id="uploadDocumentPicker" type="button" class="c-button c-button--tp c-button--icon u-no-pv u-no-p@up-to-md" (click)="vm.openFileSelect(vm.documentId)" [disabled]="vm.processing">
            <i class="o-icon o-icon--file1 c-text c-text--main c-text--lg u-no-mr" aria-hidden="true" title="{{ 'Chats.Other.Upload_Document' | translate }}"></i>
            <span class="u-sr-only">{{ 'Chats.Other.Upload_Document' | translate }}</span>
        </button>
        <form>
            <input id="{{ vm.documentId }}" class="u-hidden" name="file" type="file" accept=".pdf,.ddoc,.bdoc,.ddoc,.asice,.doc,.docx,.rft,.txt,.xls,.csv" (change)="onFileSelected($event, 'document')" [disabled]="vm.processing" />
        </form>
    </div>
	<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--center-v u-no-p" *ngIf="!vm.reserveBookingMode && !vm.aiChatActive && !vm.isPopup && !vm.chat.message?.length">
		<button id="uploadImageButton" type="button" class="c-button c-button--tp c-button--icon u-no-pv u-no-p@up-to-md" (click)="vm.openFileSelect(vm.imageId)" [disabled]="vm.processing">
			<i class="o-icon o-icon--image c-text c-text--main c-text--lg u-no-mr" aria-hidden="true" title="{{ 'Chats.Other.Upload_Image' | translate }}"></i>
			<span class="u-sr-only">{{ 'Chats.Other.Upload_Image' | translate }}</span>
		</button>
		<form>
			<input id="{{ vm.imageId }}" class="u-hidden" name="file" type="file" accept="image/*" (change)="onFileSelected($event, 'picture')" [disabled]="vm.processing" />
		</form>
	</div>
	<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--center-v u-no-p" *ngIf="!vm.reserveBookingMode && !vm.aiChatActive && !vm.isPopup && !vm.chat.message?.length">
		<button id="uploadVideoButton" type="button" class="c-button c-button--tp c-button--icon u-no-pv u-no-p@up-to-md" (click)="vm.openFileSelect(vm.videoId)" [disabled]="vm.processing">
			<i class="o-icon o-icon--video-alt c-text c-text--main c-text--lg u-no-mr" aria-hidden="true" title="{{ 'Chats.Other.Upload_Video' | translate }}"></i>
			<span class="u-sr-only">{{ 'Chats.Other.Upload_Video' | translate }}</span>
		</button>
		<form>
			<input id="{{ vm.videoId }}" class="u-hidden" name="file" type="file" accept="video/*" (change)="onFileSelected($event, 'video')" [disabled]="vm.processing" />
		</form>
	</div>
	<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--center-v u-no-p" *ngIf="!vm.reserveBookingMode && !vm.aiChatActive && !vm.isPopup && !vm.chat.message?.length && vm.canCreateBookingOffer">
		<button id="reserveBookingButton" type="button" class="c-button c-button--tp c-button--icon u-no-pv u-no-p@up-to-md" style="cursor:pointer;" (click)="vm.openBookingReservationMode()" [disabled]="vm.processing">
			<i class="o-icon o-icon--calendar-alt c-text c-text--main c-text--lg u-no-mr" aria-hidden="true" title="Offer"></i>
			<span class="u-sr-only">Offer</span>
		</button>
	</div>
	<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--center-v u-no-p" *ngIf="!vm.reserveBookingMode && !vm.aiChatActive && !vm.isPopup && !vm.chat.message?.length">
        <button id="downloadChatButton" type="button" class="c-button c-button--tp c-button--icon u-no-pv u-no-p@up-to-md" (click)="vm.downloadChat()" [disabled]="vm.processing">
            <i class="o-icon o-icon--download c-text c-text--main c-text--lg u-no-mr" aria-hidden="true" title="{{ 'Chats.Other.Download_Chat_History_Title' | translate }}"></i>
            <span class="u-sr-only">{{ 'Chats.Other.Download_Chat_History_Title' | translate }}</span>
        </button>
    </div>
</div>

<div class="o-grid o-grid--wrap@up-to-md" *ngIf="vm.reserveBookingMode" [ngStyle]="vm.getBookingReservationInputStyle()">
	<div class="o-grid__cell o-grid__cell--w-100 u-no-p">
		<div class="o-grid" [ngStyle]="vm.getBookingReservationRowStyle()">
			<div class="o-grid__cell u-no-p" style="flex:1;min-width:0;">
				<div class="c-form__group u-no-m">
					<label for="reservationDateInput" class="c-form__label u-sr-only">Date</label>
					<input-datepicker-new
						id="reservationDateInput"
						name="reservationDateInput"
						[(model)]="vm.reservationDateModel"
						[minDate]="vm.reservationMinDate"
						[hasCalendarIcon]="true"
						[isSingleDate]="true"
						[isSmall]="true"
						[isFixedPosition]="true"
						[opens]="'left'"
						[drops]="'up'"
						placeholder="DD.MM.YYYY">
					</input-datepicker-new>
				</div>
			</div>
			<div class="o-grid__cell u-no-p" style="flex:0 0 112px;">
				<div class="c-form__group u-no-m" style="position:relative;">
					<label for="reservationTimeInput" class="c-form__label u-sr-only">Time</label>
					<select id="reservationTimeInput" name="reservationTimeInput" class="c-form__input c-form__input--sm" style="background:#fff;border:1px solid #d8dde3;border-radius:6px;cursor:pointer;" [(ngModel)]="vm.reservationTime" [disabled]="vm.loading">
						<option [ngValue]="undefined">HH:mm</option>
						<option *ngFor="let time of vm.reservationTimeOptions" [ngValue]="time">{{ time }}</option>
					</select>
					<i class="o-icon o-icon--clock" style="position:absolute;right:12px;top:10px;pointer-events:none;"></i>
				</div>
			</div>
		</div>
	</div>
	<div class="o-grid__cell o-grid__cell--w-100 u-no-p" style="margin-top:10px;">
		<div style="display:flex;gap:10px;flex-wrap:wrap;">
		<button id="sendBookingReservationButton" type="button" class="c-button c-button--s1" style="margin:0;flex:1;min-width:120px;cursor:pointer;" (click)="vm.sendBookingReservation()" [disabled]="vm.loading">
				{{ 'Common.Send' | translate }}
			</button>
		<button id="cancelBookingReservationButton" type="button" class="c-button c-button--s6" style="margin:0;flex:1;min-width:120px;cursor:pointer;" (click)="vm.cancelBookingReservationMode()" [disabled]="vm.loading">
				{{ 'Common.Cancel' | translate }}
			</button>
		</div>
	</div>
</div>
